import React from "react";
import Modal from "react-bootstrap/Modal";
import "./ResetPasswordModal.scss";
import PasswordStrengthBar from "react-password-strength-bar";
import closeIcon from "../../../assets/close.svg";

import { apolloClient } from "../../../index";
import { gql } from "@apollo/client";
import { notify } from "../../Notify/Notify";

export default class ResetPasswordModal extends React.Component {
  state = {
    password: "",
    newPassword: "",
    repeatPassword: "",
    scoreLevel: 0,
    isPasswordShown: false,
    isConfirmPasswordShown: false,
    validateLength: "",
    validateLowercase: "",
    validateUppercase: "",
    validateSpecialChar: "",
    passwordValidation: true,
  };

  hasValidValues = () => {
    return (
      this.state.password.length > 0 &&
      this.state.newPassword.length > 0 &&
      this.state.password !== this.state.newPassword &&
      this.state.newPassword === this.state.repeatPassword && this.state.passwordValidation
    );
  };

  onEnterPressed = (e) => {
    if (e.key === "Enter") {
      if (this.hasValidValues()) {
        this.resetHandler(e);
      }
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({
        password: "",
        newPassword: "",
        repeatPassword: "",
        scoreLevel: 0,
      });
    }
  }

  getScoreClass = () => {
    const mapping = {
      0: "very-easy",
      1: "easy",
      2: "moderate",
      3: "good",
      4: "strong",
    };
    return mapping[this.state.scoreLevel];
  };

  resetHandler = (e) => {
    e.preventDefault();

    const variables = {
      oldPassword: this.state.password,
      newPassword: this.state.newPassword,
      confirmPassword: this.state.repeatPassword,
    };

    apolloClient
      .mutate({
        mutation: gql`
          mutation ChangePassword(
            $oldPassword: String!
            $newPassword: String!
            $confirmPassword: String!
          ) {
            changePassword(
              oldPassword: $oldPassword
              newPassword: $newPassword
              confirmPassword: $confirmPassword
            ) {
              success
              user {
                id
              }
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        if (result.data.changePassword.success) {
          this.props.handleClose();
          notify("Success", "Password changed successfully.", "success");
        }
      })
      .catch((e) => {
        
        let error_obj = {
          "Old password is incorrect" : "Please enter correct existing password.",
          "New password matches with last 5 passwords" : "New password matches with last 5 passwords. Please choose different password."
        }
        let error_message = error_obj[e.message]
        
        notify(
          "Oops...",
          error_message,
          "warning"
        );
      });
  };

  togglePasswordVisiblity = () => {
    const { isPasswordShown } = this.state;
    this.setState({ isPasswordShown: !isPasswordShown });
  };

  toggleConfirmPasswordVisiblity = () => {
    const { isConfirmPasswordShown } = this.state;
    this.setState({ isConfirmPasswordShown: !isConfirmPasswordShown });
  };
  
  passwordValidator = (e) =>{

    let validateUppercase = /[A-Z]/g;
    let validateLowercase = /[a-z]/g;
    let validateNumber = /[0-9]/g;
    let validateSpecialChar = /[!@#$%^&_]/g;
    let validPassword = true

    if(e.target.value.length > 6){
      this.setState({
        validateLength: "success"
      })
      }else{
        validPassword = false
        this.setState({
          validateLength: "fail",
        })
      }

    if(validateLowercase.test(e.target.value)){
        this.setState({
          validateLowercase: "success"
        })
      }else{
        validPassword = false
        this.setState({
          validateLowercase: "fail",
      })
    }

    if(validateUppercase.test(e.target.value)){
      this.setState({
        validateUppercase: "success"
      })
      }else{
        validPassword = false
        this.setState({
        validateUppercase: "fail",
        passwordValidation: false
        })
     }

     if(validateNumber.test(e.target.value)){
      this.setState({
        validateNumber: "success"
      })
      }else{
        validPassword = false
        this.setState({
        validateNumber: "fail",
        passwordValidation: false
        })
     }

     if(validateSpecialChar.test(e.target.value)){
      this.setState({
        validateSpecialChar: "success"
      })
      }else{
        validPassword = false
        this.setState({
        validateSpecialChar: "fail",
        passwordValidation: false
      })
     }

     this.setState({
       passwordValidation: validPassword
     })
    
  }

  render() {
    const { isPasswordShown } = this.state;
    const { isConfirmPasswordShown } = this.state;
    const bar_svg = (
      <svg width="13px" height="13px" style={{"marginBottom":"6px", "marginRight":"4px","color":"rgba(114, 113, 120,0.7)"}}>
          <g class="password-strength__icon-group" fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"><line x1="-6" y1="8" x2="8" y2="8"></line></g>
      </svg>
    )
    const success_svg = (<svg width="13px" height="13px" viewBox="0 0 512.000000 512.000000" className="mb-1 mr-1">
                      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                      fill="#008000" stroke="none">
                      <path d="M4869 5033 c-36 -17 -82 -55 -137 -112 -45 -47 -567 -671 -1158
                      -1386 -592 -715 -1082 -1301 -1088 -1302 -6 -1 -155 167 -331 374 -345 405
                      -385 449 -448 491 -196 132 -472 68 -600 -140 -80 -131 -74 -326 16 -457 17
                      -25 273 -328 570 -673 457 -533 547 -632 595 -661 90 -54 150 -70 251 -65 103
                      5 192 41 265 109 34 30 342 502 1140 1743 601 936 1101 1716 1111 1735 53 105
                      72 240 40 301 -39 75 -126 92 -226 43z"/>
                      </g>
                    </svg>)
    const failed_svg = (<svg width="13px" height="13px" viewBox="0 0 512.000000 512.000000" className="mb-1 mr-1">
                        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                        fill="#ff0000" stroke="none">
                        <path d="M780 4467 c-76 -24 -140 -120 -140 -208 1 -83 7 -90 828 -911 l787
                        -788 -787 -787 c-821 -822 -827 -829 -828 -912 -1 -121 100 -222 221 -221 83
                        1 90 7 911 828 l788 787 788 -787 c821 -821 828 -827 911 -828 121 -1 222 100
                        221 221 -1 83 -7 90 -828 912 l-787 787 787 788 c821 821 827 828 828 911 1
                        121 -100 222 -221 221 -83 -1 -90 -7 -911 -828 l-788 -787 -788 787 c-608 608
                        -797 792 -832 807 -49 22 -106 25 -160 8z"/>
                        </g>
                        </svg>)
    return (
      <Modal
        className="reset-password-modal"
        size="md"
        centered
        show={this.props.showModal}
        onHide={this.props.handleClose}
      >
        <div className="reset-password-modal-content">
          <div className="header">
            <div className="title-container">
              <h3 className="title">Reset Password</h3>
              <img
                className="close"
                src={closeIcon}
                alt="close"
                onClick={this.props.handleClose}
              />
            </div>
            <p className="sub-title">
              Enter a new password for your <b>{this.props.email}</b> account.
            </p>
          </div>

          <div className="body">
            <div className="form-groups">
              <div className="form-group">
                <label>Existing Password*</label>
                <input
                  type={isPasswordShown ? "text" : "password"}
                  className="set-width"
                  maxLength="50"
                  value={this.state.password}
                  onChange={(e) => this.setState({ password: e.target.value })}
                />
                <i
                    className={`fa ${isPasswordShown ? "fa-eye-slash" : "fa-eye"} password-icon`}
                    onClick={this.togglePasswordVisiblity}
                  />
              </div>

              <div className="form-group">
                <label>New Password*</label>
                <input
                  type="password"
                  maxLength="50"
                  value={this.state.newPassword}
                  onChange={(e) =>{
                    this.passwordValidator(e)
                    this.setState({ newPassword: e.target.value })}
                  }
                />
                 
                {this.state.password !== this.state.newPassword ? (
                  <PasswordStrengthBar
                    password={this.state.newPassword}
                    scoreWords={[
                      "Very easy password",
                      "Easy password",
                      "Moderate password",
                      "Good password",
                      "Strong password",
                    ]}
                    shortScoreWord=""
                    minLength={1}
                    onChangeScore={(score) =>
                      this.setState({ scoreLevel: score })
                    }
                    className={`password-strength-bar ${this.getScoreClass()}`}
                  />
                ) : (
                  this.state.password !== "" &&
                  this.state.newPassword !== "" && (
                    <p style={{ color: "red" }} className="password-match">
                      Existing password and new password can not be same.
                    </p>
                  )
                )}
                 <div>
                <ul className="text-decoration-none password-validator mt-3 mb-0 pl-5">
                  <li className={this.state.validateLowercase}>
                     {this.state.validateLowercase === "success" ? success_svg : this.state.validateLowercase === "fail" ? failed_svg : bar_svg}                                    
                      At least one lowercase character</li>
                  <li className={this.state.validateUppercase}>
                      {this.state.validateUppercase === "success" ? success_svg : this.state.validateUppercase === "fail" ? failed_svg : bar_svg}                                    
                      At least one uppercase character</li>  
                  <li className={this.state.validateSpecialChar} style={{"width":"256px","overflow":"inherit"}}>
                      {this.state.validateSpecialChar === "success" ? success_svg : this.state.validateSpecialChar === "fail" ? failed_svg : bar_svg}                                    
                      At least one  special character (!, @, #, _ , $, %, ^, &)</li>
                  <li className={this.state.validateLength}>
                      {this.state.validateLength === "success" ? success_svg : this.state.validateLength === "fail" ? failed_svg : bar_svg}                                    
                      At least eight character</li>
                  <li className={this.state.validateNumber}>
                    {this.state.validateNumber === "success" ? success_svg : this.state.validateNumber === "fail" ? failed_svg : bar_svg}                                    
                    At least one number</li>
                         
                </ul>
              </div>
              </div>

              <div className="form-group">
                <label>Confirm Password*</label>
                <input
                  type={isConfirmPasswordShown ? "text" : "password"}
                  maxLength="50"
                  className = "set-width"
                  value={this.state.repeatPassword}
                  onKeyPress={(e) => this.onEnterPressed(e)}
                  onChange={(e) =>
                    this.setState({ repeatPassword: e.target.value })
                  }
                />
                <i
                    className={`fa ${isConfirmPasswordShown ? "fa-eye-slash" : "fa-eye"} password-icon`}
                    onClick={this.toggleConfirmPasswordVisiblity}
                  />
                {this.state.repeatPassword.length > 0 ? (
                  <p
                    style={{
                      color:
                        this.state.newPassword === this.state.repeatPassword
                          ? "green"
                          : "red",
                    }}
                    className="password-match"
                  >
                    Passwords{" "}
                    {this.state.newPassword === this.state.repeatPassword
                      ? ""
                      : "doesn't"}{" "}
                    match
                  </p>
                ) : null}
              </div>
            </div>
          </div>

          <div className="footer">
            <button
              className="btn-tertiary cancel-button"
              onClick={this.props.handleClose}
            >
              Cancel
            </button>
            <button
              className="btn-primary create-button"
              disabled={!this.hasValidValues()}
              onClick={this.resetHandler}
            >
              Reset
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}
